// extracted by mini-css-extract-plugin
export var container = "_c0-0";
export var content = "_c0-3";
export var customerTitle = "_c0-4";
export var empty = "_c0-5";
export var gray = "_c0-6";
export var header = "_c0-7";
export var info = "_c0-8";
export var loading = "_c0-2";
export var loadingCard = "_c0-9";
export var oneLine = "_c0-a";
export var personName = "_c0-e";
export var pillContainer = "_c0-b";
export var selected = "_c0-1";
export var text = "_c0-c";
export var twoLines = "_c0-d";
export var unread = "_c0-f";
export var unreadIndicator = "_c0-g";